import { inject } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { TiimeSnackbarService } from 'tiime-material';

import { AppStoreState } from '@interfaces/app-store-state';
import { BusinessUser } from '@models/business-user';
import { businessUserSelector } from '@modules/core/store/business-user/business-user-selector';
import { ConfirmDialogService } from '@shared-dialogs/confirm-dialog/confirm-dialog.service';

export abstract class FacadeBase {
  protected store = inject(Store<AppStoreState>);
  protected confirmDialogService = inject(ConfirmDialogService);
  protected snackbar = inject(TiimeSnackbarService);

  getBusinessUser(): Observable<BusinessUser> {
    return this.store.pipe(
      select(businessUserSelector),
      filter((businessUser: BusinessUser) => !!businessUser),
      take(1)
    );
  }
}
